module.exports = __webpack_public_path__ + "img/new-preview-thumbnail.34af85d5.png";